<ng-container *ngIf="isMobile$ | async; else desktop">
  <app-bus-results-mobile
    [disabledScroll]="disableScroll"
    [isMobile]="true">
  </app-bus-results-mobile>
</ng-container>

<ng-template #desktop>
  <app-bus-results-desktop
    [disabledScroll]="disableScroll"
    [isMobile]="false">
  </app-bus-results-desktop>
</ng-template>

<router-outlet name="detail"></router-outlet>